var imagep = document.getElementById('image_cropped_preview');

/* process image functions*/





/* ave */

/* on change upload @function */

 let uploadoriginalImageData = null;
$(document).on("change",".fileinput" , function(e){

    var data=[];

    var file = null;
    file = e.target.files[0];
    if(file !== ''){
     
     
      var type = e.target.files[0].type;
      console.log('file_tye'+file.name);
var checkfile = false;


//     // allow jpg, png, jpeg, bmp, gif, ico
    // var type_rega = /^image\/(jpg|png|jpeg|bmp|gif|svg|)$/;
       var type_reg = /^image\/(png)$/;

    if (type_reg.test(type)) {
      checkfile= true;
    } else {
      // alert('This file type is unsupported.');
      $('.popup_alert').addClass('active');
      $('.content_1').html('This file type is unsupported.');
     
    }

      // alert(checkfile);
    if(checkfile == true){
      
      var reader = new FileReader();
      reader.onload = function(e){
var img = new Image();
    img.src = e.target.result;
$('.width_img').attr('src',e.target.result);
 var checkimmg = $('.width_img');  
        // alert(checkimmg.width);
//       /* image on load width and height check*/
         img.onload = function () {
        
               var w = this.width;
               
    var h = this.height;
           /* check height and width */
      if( w >= 300 && h >= 300 )
      {
 let containsColors = false;
     if ($(".front_tab.tab_items.active")[0]){
        
        const canvas = document.getElementById('imageCanvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
        uploadoriginalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = uploadoriginalImageData.data;
 const tolerance = 40;
       
      
        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];

        if (r > tolerance && g > tolerance && b > tolerance) {
          containsColors = false;
        } else if (r > 255 - tolerance  && g > 255 - tolerance && b > 255 - tolerance ) {
          containsColors = false;
          } else {
        containsColors = true;
        }
      
        }
     }

        if ($(".back_tab.tab_items.active")[0]){
     const canvas = document.getElementById('imageCanvasback');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
        uploadoriginalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = uploadoriginalImageData.data;
 const tolerance = 40;
   
      
        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];

        if (r > tolerance && g > tolerance && b > tolerance) {
          containsColors = false;
        } else if (r > 255 - tolerance  && g > 255 - tolerance && b > 255 - tolerance ) {
           containsColors = false;
         } else {
        containsColors = true;
        }
      
        }

        }
        
if (containsColors == true) {
  $('.images_popup .content_1').html('The image you have uploaded contains colors. Please make sure to upload a PNG image with no background color.');
 $('.images_popup').addClass('active');
if ($(".front_tab.tab_items.active")[0]){
  $('.front_image .conva_imgs').css('display','none');
}
  
  if ($(".back_tab.tab_items.active")[0]){
     $('.back_image .conva_imgs').css('display','none');
  }
  
$('.close_okimgs').on('click',function(){
     $(this).parents('.images_popup').removeClass('active');
 $('.cancle_btn').removeAttr('disabled');
$('.accept_btn').removeAttr('disabled'); 
        $('.accept_btn').html('<i class="fa fa-check"></i> <span>Accept</span>'); 
              /* front image*/
if ($(".front_tab.tab_items.active")[0]){
   $('.front_image .conva_imgs').css('display','block');
   $('.finvcheck').html('1');
$('#preview_img').attr('src', e.target.result);
$('#cropped_image').attr('src', e.target.result);
  $('.front_crop').attr('src', e.target.result);
// $('.front_image img.uploadingimg').removeAttr('src');
$('.review_design_uploadimg').addClass('active');
$('.input-options').addClass('hide');
$('.back_upload').addClass('hide');
$('#preview_img').css('display','block'); 
$('#cropped_image').css('display','none');  
$('#some').removeAttr('style');
$('.apply_btn').css('display','none');
  $('.undo_btn').css('display','none');
  $('.crop_img_btn').css('display','inline');
   $('.crop_img_btn').removeAttr('disabled');
  $('.invert_btn').css('display','inline');
$('.accept_btn').removeClass('hide');
$('.cancle_btn').removeClass('hide');
$('.preview_btn').addClass('hide');
$('.clear_btn').addClass('hide');
  $('.front_image .logo_img_gal').addClass('hide');  
  $('.front_image .logo_img_gal').attr('src','');  
  $('.front_image .resizable').removeClass('hide');  
  // $('.front_image .text_uploaded').html('');  
  
}

          /* back image */
if ($(".back_tab.tab_items.active")[0]){
   $('.back_image .conva_imgs').css('display','block');
  $('.binvcheck').html('1');
$('#preview_img').attr('src', e.target.result);
$('#cropped_image').attr('src', e.target.result);
  $('.back_crop').attr('src', e.target.result);
// $('.front_image img.uploadingimg').removeAttr('src');
$('.review_design_uploadimg').addClass('active');
$('.input-options').addClass('hide');
$('.back_upload').addClass('hide');
$('.accept_btn').removeClass('hide');
$('.cancle_btn').removeClass('hide');
$('.preview_btn').addClass('hide');
$('.clear_btn').addClass('hide');

$('#preview_img').css('display','block'); 
$('#cropped_image').css('display','none');  
$('#some').removeAttr('style');
$('.apply_btn').css('display','none');
  $('.undo_btn').css('display','none');
  $('.crop_img_btn').css('display','inline');
   $('.crop_img_btn').removeAttr('disabled');
  $('.invert_btn').css('display','inline');

    $('.back_image .logo_img_gal').addClass('hide');  
  $('.back_image .logo_img_gal').attr('src','');  
  $('.back_image .resizable').removeClass('hide');  
  // $('.back_image .text_uploaded').html(''); 

  
}
/* allend*/  
});

  $('.close_cancel').on('click',function(){ 
    $(this).parents('.images_popup').removeClass('active');
  $('.back_upload').removeClass('hide');
  $('#preview_img').removeAttr('src');
  $('#cropped_image').removeAttr('src');
 $('.cancle_btn').addClass('hide');
  $('.accept_btn').addClass('hide');
  $('.review_design_uploadimg').removeClass('active');
   $('.clear_btn').removeClass('hide');
  $('.preview_btn').removeClass('hide');
  $('.input-options').removeClass('hide');
  $('.fileinput').val(''); 

      if ($(".front_image.active")[0]){
    console.log('front');
    $('#imageCanvas').removeAttr('width');
    $('#imageCanvas').removeAttr('height');
    $('#uploaded-image').removeAttr('src');
     $('.front_crop').removeAttr('src');
     $('.front_image_url').html('');
    $('.front_image').removeClass('both_textactive');
     $("#inverseCheckbox").prop("checked",false);
     $("#inverseCheckbox").attr("disabled",'disabled');
         $('.front_image .conva_imgs').css('display','block');
    
 }
  if ($(".back_image.active")[0]){
    console.log('back');
  $('#imageCanvasback').removeAttr('width');
    $('#imageCanvasback').removeAttr('height');
    $('#buploaded-image').removeAttr('src');
     $('.back_crop').removeAttr('src');
     $('.back_image_url').html('');
    $('.back_image').removeClass('both_textactive');
    $("#backinverseCheckbox").prop("checked",false);
     $("#backinverseCheckbox").attr("disabled",'disabled');
    $('.back_image .conva_imgs').css('display','block');
  }
    
  });
}else{
  
  $('.cancle_btn').removeAttr('disabled');
$('.accept_btn').removeAttr('disabled'); 
        $('.accept_btn').html('<i class="fa fa-check"></i> <span>Accept</span>'); 
              /* front image*/
if ($(".front_tab.tab_items.active")[0]){
   $('.finvcheck').html('0');


  $('#preview_img').attr('src', e.target.result);
$('#cropped_image').attr('src', e.target.result);
  $('.front_crop').attr('src', e.target.result);

  
// $('.front_image img.uploadingimg').removeAttr('src');
$('.review_design_uploadimg').addClass('active');
$('.input-options').addClass('hide');
$('.back_upload').addClass('hide');
$('#preview_img').css('display','block'); 
$('#cropped_image').css('display','none');  
$('#some').removeAttr('style');
$('.apply_btn').css('display','none');
  $('.undo_btn').css('display','none');
  $('.crop_img_btn').css('display','inline');
   $('.crop_img_btn').removeAttr('disabled');
  $('.invert_btn').css('display','inline');
$('.accept_btn').removeClass('hide');
$('.cancle_btn').removeClass('hide');
$('.preview_btn').addClass('hide');
$('.clear_btn').addClass('hide');
  $('.front_image .logo_img_gal').addClass('hide');  
  $('.front_image .logo_img_gal').attr('src','');  
  $('.front_image .resizable').removeClass('hide');  
  // $('.front_image .text_uploaded').html('');  
  
}

          /* back image */
if ($(".back_tab.tab_items.active")[0]){
   $('.binvcheck').html('0');
$('#preview_img').attr('src', e.target.result);
$('#cropped_image').attr('src', e.target.result);
   $('.back_crop').attr('src', e.target.result);
// $('.front_image img.uploadingimg').removeAttr('src');
$('.review_design_uploadimg').addClass('active');
$('.input-options').addClass('hide');
$('.back_upload').addClass('hide');
$('.accept_btn').removeClass('hide');
$('.cancle_btn').removeClass('hide');
$('.preview_btn').addClass('hide');
$('.clear_btn').addClass('hide');

$('#preview_img').css('display','block'); 
$('#cropped_image').css('display','none');  
$('#some').removeAttr('style');
$('.apply_btn').css('display','none');
  $('.undo_btn').css('display','none');
  $('.crop_img_btn').css('display','inline');
   $('.crop_img_btn').removeAttr('disabled');
  $('.invert_btn').css('display','inline');

    $('.back_image .logo_img_gal').addClass('hide');  
  $('.back_image .logo_img_gal').attr('src','');  
  $('.back_image .resizable').removeClass('hide');  
  // $('.back_image .text_uploaded').html(''); 
}
/* allend*/

}
          
      }else{
         $('.popup_alert').addClass('active');
      $('.content_1').html('The image is too small. Please upload an image that is a minimum of 300px in width and height, excluding whitespace.');
      }
      };
        };
      
        reader.readAsDataURL(file);
        // $(".fileinput").value = '';
      $(".fileinput").val('');
    }else{
      console.log('hello-2');
  }
  }else{
      console.log('hello');
  }
});



















$(document).on('click','.close_ok',function (){
$('.popup_alert').removeClass('active');
});
var cropper = '';

$(document).on('click','#cropbutton',function (){
    $('#some').html('');
  var prevsrc =  $('#preview_img').attr('src');
  $('#preview_img').css('display','none');
  $('#some').css('display','block');
  $('#cropbutton').css('display','none');
  $('.invert_btn').css('display','none');
  $('#apply_crop').css('display','inline');
  $('.undo_btn').css('display','inline');
   // setTimeout(initCropper, 1000);
let img = document.createElement('img');
  img.id = 'image_cropped_preview';
  img.src = prevsrc;
$('#some').html(img);
// init cropper
cropper = new Cropper(img);
});

/* undo image*/

$(document).on('click','.undo_btn',function (){
  $('#cropbutton').removeAttr('disabled');
$('#cropbutton').css('display','inline');
$('.invert_btn').css('display','inline');
$('#apply_crop').css('display','none');
$('.undo_btn').css('display','none');
  
$('#preview_img').css('display','block');
$('#cropped_image').css('display','none');
$('#some').html('');
});

function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
  
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
  
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
  
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      var byteArray = new Uint8Array(byteNumbers);
  
      byteArrays.push(byteArray);
    }
      
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }


/* apply crop button*/

$(document).on('click', '#apply_crop', function() {
    var imgurl = cropper.getCroppedCanvas().toDataURL();
    // var base64data = imgurl.split(',')[1]; // Extract base64 part
    var img = document.getElementById("cropped_image");
    img.src = imgurl;
    $('#cropped_image').css('display', 'block');
    $('#some').css('display', 'none');
    $(this).css('display', 'none');
    $('.crop_img_btn').css('display', 'inline');
    $('.crop_img_btn').attr('disabled', 'disabled');
});


$(document).on('click','.customize-item.upload_design',function(){
  $('.customize-selection').addClass('hide');
  $('.selected_design_box').addClass('active');
  $('.inner_selected_design.design_uplod.customization-section').addClass('active');
  $('.inner_selected_design.design_uplod.customization-section').removeAttr('style');
  $('.front_tab').removeClass('hide');
  $('.back_tab').removeClass('hide');
  $('.edit_front_tab').addClass('hide');
  $('.edit_back_tab').addClass('hide');
  $('.color_customize_variants').removeAttr('style');

  $('.upload_nav_design .clear_btn').removeClass('hide');
  $('.upload_nav_design .preview_btn').removeClass('hide');
  $('.addtocart_box').addClass('hide');
  
  var front_text = $('.front_image .cstm_textup').html();
  var back_text = $('.back_image .cstm_textup').html();
  var front_image_url = $('.front_image_url').html();
   var back_image_url = $('.back_image_url').html();
  var front_inverse = $('.front_image_invert').html();
  var back_inverse = $('.back_image_invert').html();

  if(front_image_url !='' && front_inverse =="Yes"){
    console.log('1');
    // $('#inverseCheckbox').prop('checked')
    document.getElementById("inverseCheckbox").checked = true;
  }else{
    document.getElementById("inverseCheckbox").checked = false;
  }
  if(back_image_url !='' && back_inverse =="Yes"){
    console.log('2');
      document.getElementById("backinverseCheckbox").checked = true;
    // $('#backinverseCheckbox').prop('checked');
  }else{
     document.getElementById("backinverseCheckbox").checked = false;
  }
  if(front_text !='' || front_text !=' ')
  {
   
     $('.front_image .text_uploaded').removeClass('hide');
     $('.front_image .text_uploaded').addClass('active');
  }

   if(back_text !='' || back_text !=' ')
  {
      $('.back_image .text_uploaded').removeClass('hide');
    $('.back_image .text_uploaded').addClass('active');
  }
  
});




$(document).on('click','.cancle_btn',function(){

  $('.back_upload').removeClass('hide');
  $('#preview_img').removeAttr('src');
  $('#cropped_image').removeAttr('src');
 $('.cancle_btn').addClass('hide');
  $('.accept_btn').addClass('hide');
  $('.review_design_uploadimg').removeClass('active');
   $('.clear_btn').removeClass('hide');
  $('.preview_btn').removeClass('hide');
  $('.input-options').removeClass('hide');
  $('.fileinput').val('');

  if ($(".front_image.active")[0]){
     $('.gallery_name_front').html('');
    console.log('front');
    $('#imageCanvas').removeAttr('width');
    $('#imageCanvas').removeAttr('height');
    $('#uploaded-image').removeAttr('src');
     $('.front_crop').removeAttr('src');
     $('.front_image_url').html('');
    $('.front_image').removeClass('both_textactive');
     $("#inverseCheckbox").prop("checked",false);
     $("#inverseCheckbox").attr("disabled",'disabled');
    
 }
  if ($(".back_image.active")[0]){
    $('.gallery_name_back').html('');
    console.log('back');
  $('#imageCanvasback').removeAttr('width');
    $('#imageCanvasback').removeAttr('height');
    $('#buploaded-image').removeAttr('src');
     $('.back_crop').removeAttr('src');
     $('.back_image_url').html('');
    $('.back_image').removeClass('both_textactive');
    $("#backinverseCheckbox").prop("checked",false);
     $("#backinverseCheckbox").attr("disabled",'disabled');
  }  
});




$(document).on('click','.invert_btn',function(){
  if ($(".front_tab.tab_items.active")[0]){
   $('.front_image .resizable').toggleClass('invert');
    $('#preview_img').toggleClass('invert');
  }
   if ($(".back_tab.tab_items.active")[0]){
    $('.back_image .resizable').toggleClass('invert');
    $('#preview_img').toggleClass('invert');
  }
});

/* back upload*/


$(document).on('click','.back_upload',function (){
  $('.customize-selection').removeClass('hide');
   $('.selected_design_box').removeClass('active');
  $('.inner_selected_design.design_uplod.customization-section').removeClass('active');
  
});